import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_API_URL;

export const addPurchaseSlice = createAsyncThunk(
  "purchaseEntry/addPurchase",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/purchaseEntry/addPurchase", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getAllPurchaseSlice = createAsyncThunk(
  "purchaseEntry/getAllPurchase",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post("/purchaseEntry/getAllPurchase", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);

export const getPurchaseByIdSlice = createAsyncThunk(
  "purchaseEntry/getPurchaseById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        "/purchaseEntry/getPurchaseById",
        data,
        {
          headers: {
            "Content-Type": "application/json",
            token: data?.token,
          },
        }
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
export const updatePurchaseSlice = createAsyncThunk(
  "purchaseEntry/updatePurchase",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.put("/purchaseEntry/updatePurchase", data, {
        headers: {
          "Content-Type": "application/json",
          token: data?.token,
        },
      });
      return response?.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);
const initialState = {
  purchases: [],
  purchaseInfo: [],
  isLoading: false,
  createPurchaseSuccessMessage: null,
  createPurchaseErrorMessage: null,
  updatePurchaseSuccessMessage: null,
  updatePurchaseErrorMessage: null,
  searchPurchaseErrorMessage: null,
  currentPage: 1,
  totalPages: null,
  hasMore: true,
  totalCount: 0,
};

const purchaseSlice = createSlice({
  name: "purchase",
  initialState,
  reducers: {
    resetAddPurchaseMessage: (state) => {
      state.createPurchaseSuccessMessage = null;
      state.createPurchaseErrorMessage = null;
    },
    resetUpdatePurchaseMessage: (state) => {
      state.updatePurchaseSuccessMessage = null;
      state.updatePurchaseErrorMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addPurchaseSlice.pending, (state) => {
        state.isLoading = true;
        state.createPurchaseSuccessMessage = null;
        state.createPurchaseErrorMessage = null;
      })
      .addCase(addPurchaseSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.createPurchaseErrorMessage = action?.payload?.result?.message;
        } else {
          state.createPurchaseSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(addPurchaseSlice.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(getAllPurchaseSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPurchaseSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (!action.payload.success) {
          state.purchases = [];
          state.totalCount = 0;
          state.totalPages = 1;
          state.searchPurchaseErrorMessage =
            action.payload.result?.message || "No data found";
          return;
        }
        const result = action.payload.result;
        state.purchases = result.list || [];
        state.currentPage = Number(result.currentPage) || 1;
        state.totalPages = Number(result.totalPages) || 1;
        state.totalCount = Number(result.totalRecords) || 0;
        state.searchPurchaseErrorMessage = null;
      })
      .addCase(getAllPurchaseSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPurchaseErrorMessage = action?.payload?.result?.message;
      })
      .addCase(getPurchaseByIdSlice.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPurchaseByIdSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.purchaseInfo = action?.payload?.result?.list;
      })
      .addCase(getPurchaseByIdSlice.rejected, (state, action) => {
        state.isLoading = false;
        state.searchPurchaseErrorMessage = action?.payload?.result?.message;
      })
      .addCase(updatePurchaseSlice.pending, (state) => {
        state.isLoading = true;
        state.updatePurchaseSuccessMessage = null;
        state.updatePurchaseErrorMessage = null;
      })
      .addCase(updatePurchaseSlice.fulfilled, (state, action) => {
        state.isLoading = false;
        if (action.payload.success === false) {
          state.updatePurchaseErrorMessage = action?.payload?.result?.message;
        } else {
          state.updatePurchaseSuccessMessage = action?.payload?.result?.message;
        }
      })
      .addCase(updatePurchaseSlice.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});
export const { resetAddPurchaseMessage, resetUpdatePurchaseMessage } =
  purchaseSlice.actions;

export default purchaseSlice.reducer;
